import React from 'react';
import { QuizLocationDialog } from '../../components/compositions';
import TeacherToolCard from '../../components/compositions/TeacherToolCard/TeacherToolCard';
import TeacherLayoutWrapper from '../../components/layouts/TeacherLayoutWrapper/TeacherLayoutWrapper';
import './teacher-tools-view.scss';
import useTeacherToolsView from './useTeacherToolsView';

const TeacherToolsView = () => {
  const { isQuizDialogOpen, onCloseQuizDialog, onShowMobileMenu, onToolClick, shouldShowMobileMenu, t, tools } = useTeacherToolsView();

  return (
    <TeacherLayoutWrapper activeNavigationId="tools" showMobileMenu={shouldShowMobileMenu} onShowMobileMenu={onShowMobileMenu} className="teacher-tools-view">
      <div className="teacher-tools-view__content">
        {/* Section Title */}
        <div className="teacher-tools-view__header">
          <h3 className="teacher-tools-view__title">{t('teacher_tools_title')}</h3>
        </div>

        <div className="teacher-tools-view__description-container">
          <div className="teacher-tools-view__description-image" />
          <p className="teacher-tools-view__description">{t('teacher_tools_description')}</p>
        </div>

        {/* Tools Grid */}
        <div className="teacher-tools-view__grid">
          {tools.map((tool) => (
            <TeacherToolCard key={tool.id} tool={tool} onClick={onToolClick} />
          ))}
        </div>
      </div>

      {/* Quiz Location Dialog */}
      <QuizLocationDialog open={isQuizDialogOpen} onClose={onCloseQuizDialog} />
    </TeacherLayoutWrapper>
  );
};

export default TeacherToolsView;
